import React, { useEffect } from 'react'
import "./Product.css";
import { useStateValue } from './StateProvider';
import { NumericFormat } from 'react-number-format';

function Product({id,title,image,price,rating,stock,active}) {
    const [{basket},dispatch]=useStateValue();
    const findItem=basket.find(p=>p.id==id)
    useEffect(()=>{
        const user=JSON.parse(localStorage.getItem("user"))
        localStorage.setItem(`cart.${user}`,JSON.stringify(basket))
    },[basket])
    const addToBasket=()=>{
        const checkProduct=basket.find(p=>p.id==id)
        if(!checkProduct){
            dispatch({
                type:'ADD_TO_BASKET',
                item:{
                    id:id,
                    title:title,
                    image:image,
                    price:price,
                    rating:rating===undefined?null:rating,
                    count:1
                }
            })
        }
        else{
            basket.map((b)=>b.id==id?b.count=b.count+1:'')
            dispatch({
                type:"UPDATE"
            })
        }
        
    }
    const removeItem=()=>{
        if(findItem.count==1){
            dispatch({
                type:"REMOVE_FROM_BASKET",
                id:id
            })
        }else{
            findItem.count--
            dispatch({
                type:"UPDATE"
            })
        }
    }
    return (
        <div className={`product ${active===false&&'inactive_product'}`}>
            <div className="product__info">
            <p>{title}</p>
            <p className="product__price">
                    <NumericFormat
                        renderText={(value) => (
                            <strong className='order__total'>{value}</strong>
                        )}
                        decimalScale={2}
                        value={price}
                        displayType={"text"}
                        thousandSeparator
                        prefix={"₹"}
                    />
            </p>
                {
                    <div className='product__stock'>
                        {active===false&&<small className='badge badge-pill badge-info opacity-100'>Currently inactive</small>}
                        <small className='badge badge-pill badge-success'>{stock <= 10 && stock > 0 && `Hurry up, only ${stock} left`}</small>
                        <small className='badge badge-pill badge-danger'>{stock === 0 || stock===null?`Out of stock`:''}</small>
                    </div>
                }
           {/* <div className="product__rating">
                {
                    Array(rating)
                    .fill()
                    .map((_) =>(
                        <p>⭐</p>
                    ))
                }
            </div>*/}
            </div>
            <img src={image} alt="" style={{width:'100px',height:'100px'}}/>
            {findItem?
            <div className='multi_button'>
            <button className='mr-1' onClick={removeItem} disabled={findItem.count===0||stock===0} >-</button>{findItem.count}<button className='ml-1' onClick={addToBasket} disabled={findItem.count===10||stock===findItem.count || stock===null}>+</button>
            </div>
            :
            <button onClick={addToBasket} disabled={stock===0||stock===null}><small>Add to cart</small></button>
            } 
            
            
            
        </div>
    )
}

export default Product
